module.exports = __webpack_public_path__ + "img/top_bar-2.a01c9455.png";